import { render, staticRenderFns } from "./LmsControlPoints.vue?vue&type=template&id=7ecfaf65&scoped=true&"
import script from "./LmsControlPoints.vue?vue&type=script&lang=js&"
export * from "./LmsControlPoints.vue?vue&type=script&lang=js&"
import style0 from "./LmsControlPoints.vue?vue&type=style&index=0&id=7ecfaf65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecfaf65",
  null
  
)

export default component.exports